<template>
  <div>
    <ul v-show="tabsIsShown" role="tablist" :class="$style.group">
      <slot name="tabs" :tabs="tabs" :tab="tab" />
    </ul>

    <slot name="content" :tabs="tabs" :tab="tab" />
  </div>
</template>

<script>
import {
  select,
  isActive,
  selectNext,
  selectPrev,
  addTab,
  removeTab,
  isRegisteredTab
} from './symbols';

export default {
  name: 'TabGroup',
  provide() {
    return {
      [select]: this.select,
      [selectNext]: this.next,
      [selectPrev]: this.prev,
      [isActive]: this.isActive,
      [isRegisteredTab]: this.isRegisteredTab,
      [addTab]: this.addTab,
      [removeTab]: this.removeTab
    };
  },
  model: {
    event: 'change',
    prop: 'tab'
  },
  props: {
    tab: {
      type: [String, Number],
      default: null
    },
    hideSingleTab: Boolean,
    hideTabs: Boolean
  },
  emits: ['change'],
  data() {
    return {
      tabs: []
    };
  },
  computed: {
    index() {
      return this.tabs.findIndex((tab) => tab === this.tab);
    },
    tabsIsShown() {
      return !this.hideTabs && !(this.tabs.length === 1 && this.hideSingleTab);
    }
  },
  methods: {
    addTab(tab) {
      this.tabs.push(tab);
    },
    removeTab(tab) {
      this.tabs = this.tabs.filter((t) => tab !== t);
    },
    select(tab) {
      if (tab === this.tab) {
        return;
      }
      this.$emit('change', tab);
    },
    next() {
      if (this.index === -1) {
        return this.select(this.tabs[0]);
      }
      const nextTab = this.tabs[this.index + 1];
      if (nextTab) {
        this.select(nextTab);
      }
    },
    prev() {
      if (this.index === -1) {
        return this.select(this.tabs[0]);
      }
      const prevTab = this.tabs[this.index - 1];
      if (prevTab) {
        this.select(prevTab);
      }
    },
    isActive(value) {
      return this.tab === value;
    },
    isRegisteredTab(value) {
      return this.tabs.includes(value);
    }
  }
};
</script>

<style module lang="less">
@import '~@less/common/variables';

.group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
  position: relative;
  &::after {
    content: '';
    width: 100%;
    background: #ccc;
    height: 1px;
  }
}
.group:empty {
  display: none;
}
</style>

<i18n lang="json">{}</i18n>
